if (window.location.href.includes('detalle-pedido-sag')){
  function goToDetallePedido() {
    const id = document.getElementById('orderIdDetallePedido').value.trim();
    if (id) {
      window.location.href = window.location.pathname + '?order_id=' + encodeURIComponent(id);
    }
  }
  document.addEventListener("DOMContentLoaded", async () => {
    const popup = document.getElementById("popup");
    const pedidoBox = document.getElementById("pedidoBox");
  
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("order_id");
    console.log("detalle-pedido-sag' >> order_id = "+orderId);
    if (!orderId) return;
  
    popup.style.display = "none";
    pedidoBox.style.display = "block";

    try {
      const res = await fetch(`https://ororosa.api.somarimapps.com/webhook/buscar-pedido?order_id=${orderId}`);
      const data1 = await res.json();
      const data = Array.isArray(data1) ? data1[0] : data1;
  
      const datosCliente = `
        <table>
          <tr>
            <th>Número de pedido</th><td>${data.order_id}</td>
            <th>Dirección</th><td>${data.address.address1}</td>
          </tr>
          <tr>
            <th>Nombre</th><td>${data.customer_name || ''}</td>
            <th>Ciudad</th><td>${data.address.city}</td>
          </tr>
          <tr>
            <th>Cédula (empresa)</th><td>${data.cedula || 'No registrada'}</td>
            <th>País</th><td>${data.address.country}</td>
          </tr>
          <tr>
            <th>Email</th><td>${data.email}</td>
            <th></th><td></td>
          </tr>
          <tr>
            <th>Teléfono</th><td>${data.phone || '—'}</td>
            <th></th><td></td>
          </tr>
        </table>
      `;
  
      let productosHTML = `
        <table>
          <thead>
            <tr>
              <th>Imagen</th>
              <th>Producto</th>
              <th>SKU</th>
              <th>Cantidad</th>
              <th>Precio U.</th>
              <th>IVA (-)</th>
            </tr>
          </thead>
          <tbody>
      `;
  
      let totalConIva = 0;
      let totalSinIva = 0;
  
      data.productos.forEach(item => {
        const cantidad = parseInt(item.quantity || 0);
        const precio = parseFloat(item.price || 0);
        const precioSinIva = precio / 1.19;
  
        totalConIva += precio * cantidad;
        totalSinIva += precioSinIva * cantidad;
  
        const imagenHTML = item.images ? `<img src="${item.images[0]}" style="width: 100px;" />` : '';
  
        productosHTML += `
          <tr>
            <td>${imagenHTML}</td>
            <td>${item.title}</td>
            <td>${item.sku}</td>
            <td>${cantidad}</td>
            <td>${Math.round(precio).toLocaleString()}</td>
            <td><strong>${precioSinIva.toFixed(5)}</strong></td>
          </tr>
        `;
      });
  
      productosHTML += `
          </tbody>
        </table>
      `;
  
      const resumenTotales = `
        <div class="total">Total sin IVA: ${Math.round(totalSinIva).toLocaleString()}</div>
        <div class="total">Total del pedido: ${Math.round(totalConIva).toLocaleString()}</div>
      `;
  
      pedidoBox.innerHTML = datosCliente + productosHTML + resumenTotales;
  
      pedidoBox.querySelectorAll('td').forEach(cell => {
        cell.addEventListener('click', () => {
          pedidoBox.querySelectorAll('td').forEach(c => c.classList.remove('highlighted'));
          cell.classList.add('highlighted');
          const text = cell.innerText.trim();
          if (navigator.clipboard && text) {
            navigator.clipboard.writeText(text).then(() => {
              console.log(`Copiado: ${text}`);
            }).catch(err => {
              console.warn('No se pudo copiar al portapapeles:', err);
            });
          }
        });
      });
  
    } catch (err) {
      pedidoBox.innerHTML = "Error al cargar el pedido.";
      console.error(err);
    }

    
  });
}